import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { ZoneService } from 'src/app/services/zone.service';

@Component({
  selector: 'app-zone-file-uploader',
  templateUrl: './zone-file-uploader.component.html',
  styleUrls: ['./zone-file-uploader.component.scss']
})
export class ZoneFileUploaderComponent implements OnInit {

  public fileData: File = null;
  public fileName: string = "No file Chosen";
  public fileSize: any = "";
  public allowedFileTypes: any = ["text/csv"];

  public progress: number = -1;
  public errorCount: any = 0;
  public passCount: any = 0;

  constructor( 
    public dialogRef: MatDialogRef<ZoneFileUploaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,
    public zoneService: ZoneService) {
  }

  ngOnInit() {
    // console.log("ZONE IMPORT");
  }

  fileProgress(fileInput: any) {
    let fileData = <File>fileInput.target.files[0];
    if (this.allowedFileTypes.includes(fileData.type)) {
      this.fileData = fileData;
      this.fileName = fileData.name;
      this.fileSize = fileData.size;
      this.toastrService.info("File : " + this.fileName + " ; Size: " + this.fileSize, "File Selected");
    } else {
      this.fileData = null;
      this.fileName = "No file chosen";
      this.fileSize = "";
      this.toastrService.warning("Please select correct file", "Wrong File Type Error");
    }
  }

  public readFile(){

    if(this.fileData) {
        let reader: FileReader = new FileReader();
        reader.readAsText(this.fileData);
        
        reader.onload = (e) => {
          let payloadArr = [];
          let csv: string = reader.result as string;
          let rowArr = csv.split('\r\n');

          if(rowArr){
            for(let i=0;i<rowArr.length;i++){
              if(rowArr[i] && rowArr[i] != ""){
                let colArr = rowArr[i].split(',');

                if(i === 0 && !(colArr && colArr.length >= 1 && colArr[0] === 'Zone ID' && colArr[1] === 'Zone Name')){
                  this.toastrService.error("Please follow Sample CSV ","Invalid Excel Header")
                  break;
                }
                if(colArr && colArr.length >= 1 && colArr[0] !== 'Zone ID' && colArr[1] !== 'Zone Name') {
                  let zoneId = colArr[0]
                  let zoneName = colArr[1]
                  let description = colArr[2]
                  let parkingType = colArr[3]
                  let multipleTicket = colArr[4]
                  let duration = colArr[5]
                  let gracePeriod = colArr[6]

                  let ticket;
                  if(multipleTicket == "Yes"){
                    ticket = true;
                  }
                  else if(multipleTicket == "No"){
                    ticket = false;
                  }

                  if(zoneId.trim() != '' && zoneName.trim() != '' && parkingType.trim() != ''){
                    payloadArr.push({"zoneId": zoneId, "zoneName": zoneName, "description": description, "parkingType": parkingType,
                                     "multipleTicket": ticket, "duration": duration, "gracePeriod": gracePeriod});
                    this.passCount += 1;
                  }
                  else{
                    this.errorCount += 1;
                  }
                }
              }
            }
          }
          console.log(payloadArr);
          if(payloadArr && payloadArr.length > 0){
            this.bulkUpload(payloadArr);
          }
        }        
      }
  }

  bulkUpload(payloadArr){
    this.zoneService.uploadBulkZone(payloadArr)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Zone Added Successfully!");
          if(this.errorCount > 0){
            this.toastrService.info(this.passCount + ' Zone Added, </br>' + this.errorCount + ' Failed','Result',{ enableHtml:true });
          }
          else{
            this.toastrService.info(this.passCount + ' Zone Added','Result',{ enableHtml:true });
          }
          this.closeDialog();
        } 
        else {
          this.toastrService.error(response.value, "Failed To Add Zone!")
          this.closeDialog();
        }
      });
  }

  chooseFile() {
    let myInput = document.getElementById("myInput");
    myInput.click();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
